import { useQuery } from '@apollo/client';
import { GET_ALL_SURVEYS } from '@pass-frontend/common/data-access';
import { Survey } from '@pass-frontend/data-access/common/edge';

export interface CancellationReason {
  id: string;
  description: string;
}

export function useGetAllSurveys() {
  const { loading, error, data } = useQuery<{
    allSurveys: Survey[];
  }>(GET_ALL_SURVEYS);

  return {
    loading: loading ?? false,
    error,
    surveys: data,
  };
}
